import { BalanceSheetOverviewData } from '@/types/balance-sheet-overview.api';
import BalanceSheetOverviewTable from './overview/BalanceSheetOverviewTable';
import LoadingPage from '../LoadingPage';

interface BalanceSheetOverviewProps { data: BalanceSheetOverviewData; }

const BalanceOverview = (data: BalanceSheetOverviewProps) => {
    if (!data.data) return <LoadingPage />;

    return (
        <div className="bg-white rounded-2xl w-full p-8 shadow-sm">
            <BalanceSheetOverviewTable data={data.data} />
        </div>
    );
};

export default BalanceOverview;